var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorSkeletonKnee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 680,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 364 680",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doctor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.12,0s-80.84,143.19-97,172.61-28.3,41.1-21,68.88S34.15,293.06,50.32,340,83.17,437.08,110,533.46,148.61,680,148.61,680H364V415.52s-14.55-37-44.46-84.06-37.83-66.4-19.32-86.57S364,177.65,364,177.65V0Z",
    fill: "#83929f",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.22,0s-97.06,152.43-112.4,190.26,0,42,.12,74.66c.11,28.35-37.47,48.69-55.07,45.53-32.74-5.88-43.66-32.38-51.74-57.79s-10.88-64.92,17.6-83.42S236.42,0,236.42,0Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.35,198.67c3.75,14.67-8,30.65-.77,54s-5.41,34.77-17.35,33.8C31,285,25.34,244.44,22.92,222.39S62.94,181.4,67.35,198.67Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.76,370.13s16,10.92,21.7,28.58,2.42,11.54,20.21,52S305,680,305,680H284.77s-39.61-209.85-49.31-234.22-15.66-31.95-34.11-45.39S213.76,370.13,213.76,370.13Z",
    fill: "#83929f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.92,298.24c11.86-7.2,35.41,12.54,32.18,50.88-1.92,22.73-15.36,22.69-18.75,51.27S235.46,680,235.46,680H161.52S145.72,535.71,132,492.84s-46.81-107-44.39-119.58-8.4-37.59-1-49.36S130.36,333.15,187.92,298.24Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.42,235.58c-8.32,0-23.25-9.18-30.53-18s-19.8-17.23-10.71-29.83S246.77,0,246.77,0h34.77C127.93,203.71,172.83,235.51,154.42,235.58Z",
    fill: "#83929f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.8,386.94s12.64-22.7,9.55-40.35-13.91-27.73-22.65-20.17-45.11,6.73-62.9,5.88-23.71,24.38-18.73,41.19,14.54,34.46,23.51,56.32,15,55.47,15,55.47,14.16-6-7.65-85.73,9.7-29.42,30.93-44.15C190.48,333.47,178.7,358.36,191.8,386.94Z",
    fill: "#83929f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.86,680s-24.09-117.39-29.39-182.11-2.05-111.79-27.92-110.95-47.7-7.57-15.37,84.89S180.42,680,180.42,680Z",
    fill: "#83929f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.39,197.82S38,210.29,45.77,235.58s3.46,50.88,3.46,50.88-16.71-5.17-21.29-32.65S14,212.44,32.41,202.6,56.39,197.82,56.39,197.82Z",
    fill: "#83929f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorSkeletonKnee);
export default __webpack_public_path__ + "static/media/doctor_skeleton-knee.30e5fd8ab916d3cb34565c50597a007e.svg";
export { ForwardRef as ReactComponent };